import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../auth-n-routing/auth-service.service';
import {Observable} from 'rxjs';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	constructor(public router: Router, public authService: AuthService, private activatedRoute: ActivatedRoute) {
		const routeFragment: Observable<string> = activatedRoute.fragment;
		routeFragment.subscribe(fragment => {
			if (fragment) {
				const token: string = fragment.match(/^(.*?)&/)[1].replace('code=', '');
				console.log(token);
			}
		});

	}

	ngOnInit() {
		this.authService.goToGaia(true);
	}

	logIn() {
		this.authService.goToGaia(false);
	}
}
